import React from 'react';
import { useTranslation } from "react-i18next";
import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"


const ItemTagsTable = ({ItemTagsData}) => {
    //const branchesTags=[]
    const { t } = useTranslation();
    //console.log(ItemTagsData)
  return (
    <Box
    bg="light" overflow="auto"
    borderRadius={4} boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
  >
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>{t("pages.branches.name")}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {ItemTagsData.map((el, index) => (
          <Tr key={el.ItemsTagsId}>
            <Td>{index + 1}</Td>
            <Td>{el?.InventoryItem[0].Tag[0].TagName            }</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
  );
}

export default ItemTagsTable;
